/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   search\client\webapi\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Search_Shared_Contracts = require("Search.Client/Shared/Search.Shared.Contracts");

/**
 * Defines the Board result that matched a Board search request.
 */
export interface BoardResult {
    /**
     * Board Type of the board document.
     */
    boardtype: string;
    /**
     * Collection details of the baord document.
     */
    collection: Search_Shared_Contracts.Collection;
    /**
     * Project details of the board document.
     */
    project: Project;
    /**
     * Team details of the board document.
     */
    team: Team;
}

/**
 * Defines a Board search request.
 */
export interface BoardSearchRequest extends Search_Shared_Contracts.EntitySearchRequest {
}

/**
 * Defines a Board search response item.
 */
export interface BoardSearchResponse extends Search_Shared_Contracts.EntitySearchResponse {
    /**
     * Total number of matched Board documents.
     */
    count: number;
    /**
     * List of top matched Board documents.
     */
    results: BoardResult[];
}

/**
 * Information about the configured branch.
 */
export interface BranchInfo {
    /**
     * @internal
     * The commit Id of the last Git commit indexed in this branch
     */
    lastIndexedChangeId: string;
    /**
     * @internal
     * The last time this branch was processed by the Search service
     */
    lastProcessedTime: Date;
    /**
     * Name of the indexed branch
     */
    name: string;
}

/**
 * Defines the code result containing information of the searched files and its metadata.
 */
export interface CodeResult {
    /**
     * Collection of the result file.
     */
    collection: Search_Shared_Contracts.Collection;
    /**
     * ContentId of the result file.
     */
    contentId: string;
    /**
     * Name of the result file.
     */
    fileName: string;
    /**
     * Dictionary of field to hit offsets in the result file. Key identifies the area in which hits were found, for ex: file content/file name etc.
     */
    matches: { [key: string] : Search_Shared_Contracts.Hit[]; };
    /**
     * Path at which result file is present.
     */
    path: string;
    /**
     * Project of the result file.
     */
    project: Project;
    /**
     * Repository of the result file.
     */
    repository: Search_Shared_Contracts.Repository;
    /**
     * Versions of the result file.
     */
    versions: Search_Shared_Contracts.Version[];
}

/**
 * Defines a code search request.
 */
export interface CodeSearchRequest extends Search_Shared_Contracts.EntitySearchRequest {
    /**
     * Flag to opt for including matched code snippet in the result. Default behavior is false.
     */
    includeSnippet: boolean;
}

/**
 * Defines a code search response item.
 */
export interface CodeSearchResponse extends Search_Shared_Contracts.EntitySearchResponse {
    /**
     * Total number of matched files.
     */
    count: number;
    /**
     * List of matched files.
     */
    results: CodeResult[];
}

export interface CustomRepositoryBranchStatusResponse {
    lastIndexedChangeId: number;
    lastIndexedChangeIdChangeTime: Date;
    latestChangeId: number;
    latestChangeIdChangeTime: Date;
}

/**
 * Defines the custom repository status.
 */
export interface CustomRepositoryStatusResponse {
    /**
     * Repository Id.
     */
    id: string;
    /**
     * List of indexed top level folders info.
     */
    indexedTopLevelFolders: DepotInfo[];
    /**
     * Repository Name.
     */
    name: string;
}

/**
 * Information about the custom repository indexing freshness for configured branches and depots.
 */
export interface DepotInfo {
    /**
     * @internal
     * List of Indexed branches info.
     */
    indexedBranches: BranchInfo[];
    /**
     * Name of the indexed top level folder (depot).
     */
    name: string;
}

/**
 * Defines the details of the project.
 */
export interface Project {
    /**
     * Id of the project.
     */
    id: string;
    /**
     * Name of the project.
     */
    name: string;
}

/**
 * Defines the repository status.
 */
export interface RepositoryStatusResponse {
    /**
     * Repository Id.
     */
    id: string;
    /**
     * List of Indexed branches info.
     */
    indexedBranches: BranchInfo[];
    /**
     * Repository Name.
     */
    name: string;
}

/**
 * Defines the details of the team.
 */
export interface Team {
    /**
     * Id of the team.
     */
    id: string;
    /**
     * Name of the Team.
     */
    name: string;
}

/**
 * Defines the TFVC repository status.
 */
export interface TfvcRepositoryStatusResponse {
    /**
     * Repository Id.
     */
    id: string;
    /**
     * List of Indexing Information for TFVC repository
     */
    indexingInformation: BranchInfo[];
    /**
     * Repository Name.
     */
    name: string;
}

/**
 * Defines the matched terms in the field of the work item result.
 */
export interface WorkItemHit {
    /**
     * Reference name of the highlighted field.
     */
    fieldReferenceName: string;
    /**
     * Matched/highlighted snippets of the field.
     */
    highlights: string[];
}

/**
 * Defines the work item result that matched a work item search request.
 */
export interface WorkItemResult {
    /**
     * A standard set of work item fields and their values.
     */
    fields: { [key: string] : string; };
    /**
     * Highlighted snippets of fields that match the search request. The list is sorted by relevance of the snippets.
     */
    hits: WorkItemHit[];
    /**
     * Project details of the work item.
     */
    project: Project;
    /**
     * Reference to the work item.
     */
    url: string;
}

/**
 * Defines a work item search request.
 */
export interface WorkItemSearchRequest extends Search_Shared_Contracts.EntitySearchRequest {
}

/**
 * Defines a response item that is returned for a work item search request.
 */
export interface WorkItemSearchResponse extends Search_Shared_Contracts.EntitySearchResponse {
    /**
     * Total number of matched work items.
     */
    count: number;
    /**
     * List of top matched work items.
     */
    results: WorkItemResult[];
}

export var TypeInfo = {
    BranchInfo: <any>{
    },
    CodeResult: <any>{
    },
    CodeSearchResponse: <any>{
    },
    CustomRepositoryBranchStatusResponse: <any>{
    },
    CustomRepositoryStatusResponse: <any>{
    },
    DepotInfo: <any>{
    },
    RepositoryStatusResponse: <any>{
    },
    TfvcRepositoryStatusResponse: <any>{
    },
};

TypeInfo.BranchInfo.fields = {
    lastProcessedTime: {
        isDate: true,
    }
};

TypeInfo.CodeResult.fields = {
    repository: {
        typeInfo: Search_Shared_Contracts.TypeInfo.Repository
    }
};

TypeInfo.CodeSearchResponse.fields = {
    results: {
        isArray: true,
        typeInfo: TypeInfo.CodeResult
    }
};

TypeInfo.CustomRepositoryBranchStatusResponse.fields = {
    lastIndexedChangeIdChangeTime: {
        isDate: true,
    },
    latestChangeIdChangeTime: {
        isDate: true,
    }
};

TypeInfo.CustomRepositoryStatusResponse.fields = {
    indexedTopLevelFolders: {
        isArray: true,
        typeInfo: TypeInfo.DepotInfo
    }
};

TypeInfo.DepotInfo.fields = {
    indexedBranches: {
        isArray: true,
        typeInfo: TypeInfo.BranchInfo
    }
};

TypeInfo.RepositoryStatusResponse.fields = {
    indexedBranches: {
        isArray: true,
        typeInfo: TypeInfo.BranchInfo
    }
};

TypeInfo.TfvcRepositoryStatusResponse.fields = {
    indexingInformation: {
        isArray: true,
        typeInfo: TypeInfo.BranchInfo
    }
};
